export function faqAcd() {
    if (document.getElementById('faq')){
        const acds = document.getElementsByClassName('faq_item');

        for (let i = 0,len = acds.length; i < len; i++){
            acds[i].addEventListener('click',function () {
                acds[i].classList.toggle('open');

                let closeTgt = acds[i].getElementsByClassName('faq_item_answer')[0]

                if (closeTgt.style.height){
                    closeTgt.style.height = null;
                }else {
                    closeTgt.style.height = closeTgt.scrollHeight + 'px';
                }
            })
        }
    }
}